import React from 'react';

export default function StatCard({ label, value, delta, positive, color }) {
  return (
    <div className="stat-card">
      <div className="stat-label">{label}</div>
      <div className="stat-value" style={{ color: color || '#111' }}>{value}</div>
      {delta && (
        <div className="stat-delta" style={{ color: positive ? '#1d9e75' : '#e24b4a' }}>
          {positive ? '↑' : '↓'} {delta}
        </div>
      )}
    </div>
  );
}
